import { CREATE_HELP_TOPIC_ARTICLE, DELETE_HELP_TOPIC_ARTICLE, UPDATE_HELP_TOPIC_ARTICLE_ORDERS, GET_HELP_TOPICS_FOR_LOCALE, UPDATE_HELP_TOPIC_ARTICLE } from '../action-types'
import { SET_HELP_DATA, SET_HELP_LOADING, SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT } from '../mutation-types'
import server from '../server'
import { informationTexts } from './information'

const state = {
  helpTopics: {
    loading: false,
    data: {}
  }
}

const mutations = {
  [SET_HELP_LOADING] (state, loading) {
    state.helpTopics.loading = loading
  },
  [SET_HELP_DATA] (state, {data, locale}) {
    const nextAvailableId = `${(data.articles || []).reduce((t, c) => t > +c.id ? t : +c.id, 0) + 1}`
    state.helpTopics.data = {
      ...state.helpTopics.data,
      [locale]: {
        ...data,
        articles: (data.articles || []).filter(x => !x.deleted),
        nextAvailableId
      }
    }
  }
}

const actions = {
  [GET_HELP_TOPICS_FOR_LOCALE] ({commit, state}, {locale, forceRefresh}) {
    if (!forceRefresh && state.helpTopics.data[locale] && state.helpTopics.data[locale].length) {
      return
    }

    commit(SET_HELP_LOADING, true)
    const url = `/core/help/help/${locale}`
    server.getReplayable(url).then(({data}) => {
      commit(SET_HELP_DATA, {data, locale})
      commit(SET_HELP_LOADING, false)
    }).catch((e) => {
      console.error(e)
      commit(SET_HELP_LOADING, false)
    })
  },
  [DELETE_HELP_TOPIC_ARTICLE] ({commit, state, dispatch}, {locale, articleId}) {
    const helpDataOfLocale = JSON.parse(JSON.stringify(state.helpTopics.data[locale]))
    const idx = helpDataOfLocale.articles.findIndex(x => x.id === articleId)
    helpDataOfLocale.articles[idx].deleted = true
    helpDataOfLocale.article_ids = generateArticleIds(helpDataOfLocale)

    commit(SET_HELP_LOADING, true)
    const data = {...helpDataOfLocale, locale}
    saveToServer(data)
      .then(() => {
        commit(SET_HELP_LOADING, false)
        commit(SET_HELP_DATA, {data, locale: data.locale})
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.HELP_TOPIC_ARTICLE_DELETED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((e) => {
        console.error(e)
        commit(SET_HELP_LOADING, false)
      })
  },
  [UPDATE_HELP_TOPIC_ARTICLE_ORDERS] ({commit, state, dispatch}, {locale, articles}) {
    const helpDataOfLocale = Object.assign({}, state.helpTopics.data[locale])
    helpDataOfLocale.articles = articles

    commit(SET_HELP_LOADING, true)
    const data = {...helpDataOfLocale, locale}
    saveToServer(data)
      .then(() => {
        commit(SET_HELP_LOADING, false)
        commit(SET_HELP_DATA, {data, locale: data.locale})
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.HELP_TOPIC_ARTICLE_ORDER_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((e) => {
        console.error(e)
        commit(SET_HELP_LOADING, false)
      })
  },
  [UPDATE_HELP_TOPIC_ARTICLE] ({commit, dispatch}, {locale, article}) {
    const helpDataOfLocale = Object.assign({}, state.helpTopics.data[locale])
    const idx = helpDataOfLocale.articles.findIndex(x => x.id === article.id)
    helpDataOfLocale.articles[idx] = article

    commit(SET_HELP_LOADING, true)
    const data = {...helpDataOfLocale, locale}
    saveToServer(data)
      .then(() => {
        commit(SET_HELP_LOADING, false)
        commit(SET_HELP_DATA, {data, locale: data.locale})
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.HELP_TOPIC_ARTICLE_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((e) => {
        console.error(e)
        commit(SET_HELP_LOADING, false)
      })
  },
  [CREATE_HELP_TOPIC_ARTICLE] ({commit, dispatch, state}, {locale, article}) {
    const nextId = state.helpTopics.data[locale].nextAvailableId
    const newHelpData = {
      ...state.helpTopics.data[locale],
      articles: [
        ...state.helpTopics.data[locale].articles,
        {
          ...article,
          id: nextId
        }
      ]
    }
    newHelpData.article_ids = generateArticleIds(newHelpData)

    commit(SET_HELP_LOADING, true)
    const data = {...newHelpData, locale}
    saveToServer(data)
      .then(() => {
        dispatch(GET_HELP_TOPICS_FOR_LOCALE, {locale, forceRefresh: true})
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.HELP_TOPIC_ARTICLE_CREATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
      })
      .catch((e) => {
        console.error(e)
        commit(SET_HELP_LOADING, false)
      })
  }
}

function generateArticleIds (data) {
  const ids = data.articles.map(x => x.id)
  return `[${ids.join(', ')}]`
}

function saveToServer (data) {
  const url = `/core/help/saveHelp`
  return server.postReplayable(url, data).catch((e) => {
    console.error(e)
  })
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/helpModule.js